import { useEffect, useState } from "react";

const KEY = "ageing_basis";
const EVT = "ageing-basis-changed";

/** Due-date vs invoice-date ageing, shared by AP/AR Ageing, Dashboard and Vendor 360 (persisted in localStorage). */
export function useAgeingBasis() {
  const [basis, setState] = useState(() => (localStorage.getItem(KEY) === "invoice" ? "invoice" : "due"));
  useEffect(() => {
    const sync = () => setState(localStorage.getItem(KEY) === "invoice" ? "invoice" : "due");
    window.addEventListener(EVT, sync); window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const setBasis = (b) => { localStorage.setItem(KEY, b); setState(b); window.dispatchEvent(new Event(EVT)); };
  return [basis, setBasis];
}

export const BASIS_LABEL = { due: "due date (SAP net due date)", invoice: "invoice date" };

export const AgeingBasisToggle = ({ basis, onChange, testPrefix }) => (
  <div className="inline-flex items-center rounded-md border border-slate-200 overflow-hidden text-xs h-9" title="Which date the ageing clock starts from" data-testid={`${testPrefix}-basis`}>
    <span className="px-2 text-slate-500 bg-slate-50 h-full inline-flex items-center border-r border-slate-200">Age by</span>
    {[["due", "Due date"], ["invoice", "Invoice date"]].map(([k, l]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testPrefix}-basis-${k}`} className={`px-3 h-full ${basis === k ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
    ))}
  </div>
);
